import { useMutationState } from '@tanstack/react-query';
import type { SaveState } from '../components/v2/ds';
import { isRecordWriteKey } from './api/useBrandOnboarding';

/**
 * The slim bar's save status: the latest record write (updateSection or
 * confirmFields, never a photo upload) in this session, read from React Query's mutation cache. Nothing written yet means
 * nothing is claimed ("idle"), never a standing "Saved".
 */
export function useOnboardingSaveStatus(): { state: SaveState; at: number | null } {
  const states = useMutationState({
    filters: { predicate: (m) => isRecordWriteKey(m.options.mutationKey) },
    select: (m) => ({ status: m.state.status, at: m.state.submittedAt }),
  });
  const last = states.reduce<(typeof states)[number] | null>((a, b) => (a === null || b.at >= a.at ? b : a), null);
  if (!last) return { state: 'idle', at: null };
  if (last.status === 'pending') return { state: 'saving', at: null };
  if (last.status === 'error') return { state: 'error', at: null };
  if (last.status === 'success') return { state: 'saved', at: last.at };
  return { state: 'idle', at: null };
}
